module.exports = __webpack_public_path__ + "img/sender-du-ikke-lige-6.7a60ec6e.png";